export default __webpack_public_path__ + "static/media/icon_2.c599180f.svg";